import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApproachProfileComponent } from 'src/app/shared/dialogs/approach-profile/approach-profile.component';
import { AttestationComponent } from 'src/app/shared/dialogs/attestation/attestation.component';
import { CopyApproachProfilesComponent } from 'src/app/shared/dialogs/copy-approach-profiles/copy-approach-profiles.component';
import { TemplateComponent } from 'src/app/shared/dialogs/template/template.component';
import { UserGuideViewComponent } from 'src/app/shared/dialogs/user-guide-view/user-guide-view.component';
import { CopyStipendConfigComponent } from 'src/app/shared/dialogs/copy-stipend-config/copy-stipend-config.component';
import { UserGuideEditorComponent } from 'src/app/shared/dialogs/user-guide-editor/user-guide-editor.component';
import { TeachingFieldComponent } from 'src/app/shared/dialogs/teaching-field/teaching-field.component';
import { TeachingFieldAssignmentComponent } from 'src/app/shared/dialogs/teaching-field-assignment/teaching-field-assignment.component';
import { NotificationTemplateDialogComponent } from 'src/app/shared/dialogs/notification-template/notification-template.component';
import { PdfUserGuideUploadComponent } from 'src/app/shared/dialogs/pdf-user-guide-upload/pdf-user-guide-upload.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) { }

  addTemplate(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(TemplateComponent, {
      data: config,
      width: '500px'
    });
  }

  addProfile(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(ApproachProfileComponent, {
      data: config,
      width: '500px'
    });
  }

  addAttestation(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(AttestationComponent, {
      data: config,
      width: '800px'
    });
  }

  copyProfiles() {
    return this.dialog.open(CopyApproachProfilesComponent, {
      width: '500px'
    });
  }

  viewGuide(guide: any) {
    return this.dialog.open(UserGuideViewComponent, {
      data: guide,
      width: '900px',
      maxHeight: '90vh'
    });
  }

  copyStipendConfig() {
    return this.dialog.open(CopyStipendConfigComponent, {
      width: '500px'
    });
  }

  editGuide(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(UserGuideEditorComponent, {
      data: config,
      width: '1100px',
      maxHeight: '90vh'
    });
  }

  addTeachingField(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(TeachingFieldComponent, {
      data: config,
      width: '500px'
    });
  }

  assignTeachingField(action: 'add' | 'edit', data: any) {
    const config = { action, data };
    return this.dialog.open(TeachingFieldAssignmentComponent, {
      data: config,
      width: '500px'
    });
  }

  editNotificationTemplate(data: any) {
    const action = data ? 'edit' : 'add';
    return this.dialog.open(NotificationTemplateDialogComponent, {
      data: { action, data },
      width: '700px',
      maxHeight: '90vh'
    });
  }

  uploadPdfUserGuide() {
    return this.dialog.open(PdfUserGuideUploadComponent, {
      width: '500px'
    });
  }
}
